import { useMutation } from "@tanstack/react-query";
import { uploadMedia as apiUploadMedia } from "../../api/apiMedias";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUploadMedia() {
    const { enqueueSnackbar } = useSnackbar();

    const {
        mutate: uploadMedia,
        isPending,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiUploadMedia(req),
        onError: (err) => {
            console.error("Error:", err);
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { isPending, error, uploadMedia, results };
}
